export class AddWellnessUser {
  public portalName?: string;
  public username?: string;
  public firstName?: string;
  public lastName?: string;
  public email?: string;
  public countryId?: number;
  public password?: string;
}
